module.exports = __webpack_public_path__ + "static/media/budva-2.78ec0d15.jpg";